<template>
  <div style="min-height: 400px;">
   <h2>  Select Cells</h2>
    <div style="margin-top:20px">
      <liquor-tree
      :data="treeData"
      :options="treeOptions"
      :checkbox="true"
      :checkOnSelect="true"
    />
    <b-button
              variant="outline-primary"
              style="margin-top: 25px!important;"
            >
               PERFORM DIGITAL RECONSTRUCTION
            </b-button>

    </div>
  
    
      
  
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import LiquorTree from 'liquor-tree'
import {
  BFormGroup, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    Multiselect,
    BFormGroup,
    BButton,
    vSelect,
    LiquorTree
  },
  props: {
    data: {
      required: true,
      type: [String, Object, Array],
    },
   
  },
  data() {
    return {
      test: ['prueba'],
      cluster: '',
      name: '',
      error: false,
      newNames: [],
      treeOptions: 
      {
  "selected": true,
  "selectable": true,
  "checked": true,
  "expanded": true,
  "disabled": false,
  "visible": true,
  "indeterminate": false,
  "matched": false,
  "editable": true,
  "dragging": false,
  "draggable": true,
  "dropable": true,
  "checkbox":true,
  "checkOnSelect":true
},
      
      treeData : [
  { text: 'Parent node test',state: { checkbox:true, checkOnSelect:true }, children: [
    {text: 'Version 72', children: [
      { text: 'Cell B', state: { selectable: true }},
      { text: 'Blanc', state: { selectable: true } }
    ]}]},

  { text: 'Children 1 test', children: [
    { text: 'Version 80', state: { selectable: true }, children: [
      { text: 'Cell B', state: { selectable: true } }

    ] },
    
  ]}
  // and so on ...
]
    }
  },
  computed: {
   
  },
  methods: {
    
    addAnnotation() {
      if (this.cluster !== '') {
        this.add({ name: this.name, cluster: this.cluster })
      } else {
        this.error = true
      }
    },
    addName(newName) {
      // if (this.alphanumeric(newName)) {
      this.newNames.push({ name: newName })
      this.name = { name: newName }
      /* } else {
        this.error = true
      } */
    },
    alphanumeric(inputtxt) {
      const letterNumber = /^[0-9a-zA-Z ]+$/
      if (inputtxt.value.match(letterNumber)) {
        return true
      }
      return false
    },
  },
}
</script>
<style>
.tree-checkbox{
  width: 15px !important;
  height: 15px !important;

}


</style>

